import { Component, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../../../shared/services/common.service";
import { Store } from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import { GenerateOtpRequest, VerifyOtpForTfaRequest, VerifyOtpRequest } from "../../../../core/authentication.actions";
import { Subject, takeUntil } from "rxjs";
import { Router } from "@angular/router";
import { phoneNumber, verifyOtpForTfaInfo, verifyOtpInfo } from "../../../../core/authentication.selectors";
import * as Validation from "../../../../../shared/constants/validation.constants";
import { AuthenticationService } from "../../../../core/authentication.service";
import { PhoneNumberFormatPipe } from "../../../../../shared/pipes/phone-number-format.pipe";

@Component({
  selector: "app-step-three-right-panel",
  templateUrl: "./step-three-right-panel.component.html",
  styleUrls: ["./step-three-right-panel.component.css"]
})
export class StepThreeRightPanelComponent implements OnDestroy {
  private readonly onDestroy: Subject<any> = new Subject<any>();
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    otp: {
      required: "This field is required.",
      minlength: "OTP is incomplete",
      maxlength: "Maximum 6 digits accepted",
    }
  };
  phoneNumber: string = null;
  formatedPhoneNumber: string = null;
  verifyOtpLoading: boolean = false;
  tfa: boolean = false;
  generateOtpRequest: boolean = false;
  generateOtpSuccess: boolean = false;
  generateOtpFailure: boolean = false;
  timerValue = 30;

  form = new FormGroup({
    otp: new FormControl("", {
      validators: [
        Validators.required,
        Validators.minLength(this.validation.onboarding.otp.length.min),
        Validators.maxLength(this.validation.onboarding.otp.length.max),
      ],
    }),
  });

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private authenticationService: AuthenticationService,
    private phoneNumberFormatPipe: PhoneNumberFormatPipe,
    private router: Router,
  ) {

    this.tfa = this.router.url === "/auth/two-factor-authentication";

    this.store.select(phoneNumber).pipe(takeUntil(this.onDestroy)).subscribe(data => {
      this.phoneNumber = data?.phoneNumber;
      this.formatedPhoneNumber = this.phoneNumberFormatPipe.transform(data?.phoneNumber);
    });

    this.authenticationService.generateOtpSuccess.pipe(takeUntil(this.onDestroy)).subscribe(data => {
      if (data) {
        this.generateOtpRequest = false;
        this.generateOtpSuccess = true;
        this.generateOtpFailure = false;
      }
    });

    this.authenticationService.generateOtpFailure.pipe(takeUntil(this.onDestroy)).subscribe(data => {
      this.generateOtpRequest = false;
      this.generateOtpSuccess = false;
      this.generateOtpFailure = true;
    });

    this.store.select(verifyOtpInfo).pipe(takeUntil(this.onDestroy)).subscribe(data => {
      this.verifyOtpLoading = data.loading;
    });

    this.store.select(verifyOtpForTfaInfo).pipe(takeUntil(this.onDestroy)).subscribe(data => {
      this.verifyOtpLoading = data.loading;
    });

  }

  verifyOtp() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    // EXTRACT VALUE FROM FORM//
    const {otp} = this.form.getRawValue();
    // PAYLOAD CREATION//
    const payload = {
      otp
    };
    // ACTION DISPATCH to get OTP
    if (this.tfa) {
      this.store.dispatch(VerifyOtpForTfaRequest({payload}));
    } else {
      this.store.dispatch(VerifyOtpRequest({payload}));
    }
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  resend() {
    if(this.generateOtpRequest || this.generateOtpSuccess) {
      return;
    }
    this.generateOtpRequest = true;
    this.generateOtpSuccess = false;
    this.generateOtpFailure = false;
    this.store.dispatch(GenerateOtpRequest({payload: {phoneNumber: this.phoneNumber}, resend: true}));
  }

  changePhoneNumber() {
    this.router.navigate(["auth/register/step-2"]);
  }

  handleCounterComplete() {
    this.generateOtpSuccess = false;
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
